import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/raffle-drum.jpg'


const _hoisted_1 = { class: "w-100 h-100 p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "bi bi-chevron-left" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "card card-flush h-md-100 p-0"
}
const _hoisted_4 = {
  class: "card-body p-0 d-flex flex-column justify-content-between bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0",
  style: {"background-position":"100% 50%","background-image":"url('/metronic8/vue/demo1//media/stock/900x600/42.png')"}
}
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-40",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "card card-flush h-md-100"
}
const _hoisted_9 = {
  class: "card-body d-flex flex-column justify-content-between mt-9 bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0",
  style: {"background-position":"100% 50%","background-image":"url('/metronic8/vue/demo1//media/stock/900x600/42.png')"}
}
const _hoisted_10 = { class: "mb-10" }
const _hoisted_11 = { class: "fs-5hx fw-bold text-gray-800 text-center mb-13" }
const _hoisted_12 = { class: "me-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "position-relative d-inline-block text-danger" }
const _hoisted_15 = {
  href: "/metronic8/vue/demo1/crafted/account/overview",
  class: "text-danger opacity-75-hover"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "position-absolute opacity-15 bottom-0 start-0 border-4 border-danger border-bottom w-100" }, null, -1)
const _hoisted_17 = { class: "d-flex justify-content-center" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "d-flex justify-content-center mt-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-auto h-150px h-lg-200px theme-light-show",
  src: "/metronic8/vue/demo1/media/illustrations/misc/upgrade.svg",
  alt: ""
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-auto h-150px h-lg-200px theme-dark-show",
  src: "/metronic8/vue/demo1/media/illustrations/misc/upgrade-dark.svg",
  alt: ""
}, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "card card-flush h-md-100 p-0"
}
const _hoisted_23 = {
  class: "card-body p-0 d-flex flex-column justify-content-between bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0",
  style: {"background-position":"100% 50%","background-image":"url('/metronic8/vue/demo1//media/stock/900x600/42.png')"}
}
const _hoisted_24 = { class: "mb-10" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5hx fw-bold text-gray-800 text-center mb-13" }, " CONGRATULATIONS!!! ", -1)
const _hoisted_26 = { class: "fs-2hx fw-bold text-gray-800 text-center mb-13" }
const _hoisted_27 = { class: "me-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { class: "position-relative d-inline-block text-danger" }
const _hoisted_31 = {
  href: "/metronic8/vue/demo1/crafted/account/overview",
  class: "text-danger opacity-75-hover fs-5hx"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "position-absolute opacity-15 bottom-0 start-0 border-4 border-danger border-bottom w-100" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = { class: "fs-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = { class: "fs-5" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "fs-6" }, "Please expect a call from our team on how to claim your price.")
], -1)
const _hoisted_38 = { class: "card draw-card" }
const _hoisted_39 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormCheckInput = _resolveComponent("FormCheckInput")!
  const _component_Card = _resolveComponent("Card")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "draw-card m-h-100 w-100",
          style: {"height":"calc(100vh)"}
        }, {
          title: _withCtx(() => [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToDrawLists && _ctx.returnToDrawLists(...args)))
            }, [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.drawData ? _ctx.drawData.title : ''), 1)
            ])
          ]),
          default: _withCtx(() => [
            (!_ctx.showWinner)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.startDraw)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _hoisted_7,
                            _createTextVNode(" " + _toDisplayString(_ctx.counterTimer), 1)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("span", _hoisted_12, [
                                _createTextVNode(" Who will be the winner of "),
                                _hoisted_13,
                                _createElementVNode("span", _hoisted_14, [
                                  _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.drawData ? _ctx.drawData.prize : ''), 1),
                                  _hoisted_16
                                ])
                              ]),
                              _createTextVNode(" for our "),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.drawData ? _ctx.drawData.title : ''), 1),
                              _createTextVNode("? ")
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("button", {
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startDrawLots && _ctx.startDrawLots(...args))),
                                class: "btn btn-lg btn-primary fw-bold fs-2hx",
                                disabled: !_ctx.drawButtonEnable
                              }, " Pick the lucky winner ", 8, _hoisted_18)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_FormCheckInput, {
                                modelValue: _ctx.drawButtonEnable,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.drawButtonEnable) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Enable draw button and initialize draw ")
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]),
                          _hoisted_20,
                          _hoisted_21
                        ])
                      ]))
                ], 64))
              : _createCommentVNode("", true),
            (!_ctx.startDraw && _ctx.showWinner)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, [
                          _createTextVNode(" The lucky winner of "),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.drawData ? _ctx.drawData.title : ''), 1),
                          _createTextVNode(" is "),
                          _hoisted_28,
                          _hoisted_29,
                          _createElementVNode("span", _hoisted_30, [
                            _createElementVNode("a", _hoisted_31, _toDisplayString(_ctx.drawLotData ? _ctx.drawWinner : ''), 1),
                            _hoisted_32
                          ])
                        ]),
                        _hoisted_33,
                        _createElementVNode("small", _hoisted_34, " You will receive " + _toDisplayString(_ctx.drawData ? _ctx.drawData.prize : ''), 1),
                        _hoisted_35,
                        _createElementVNode("small", _hoisted_36, " (Entry Code: " + _toDisplayString(_ctx.drawLotData ? _ctx.drawLotData.entry_code : '') + ") ", 1)
                      ]),
                      _hoisted_37
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("template", null, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_el_skeleton, {
            rows: 5,
            animated: true
          })
        ])
      ])
    ])
  ]))
}